

import Accounts from "./Accounts";


class Facebook extends Accounts{
    constructor(params) {
      super(params);
    
    this.accountLabel = "Facebook";
    this.accountType = "Facebook";
    this.isParent = true;
  this.setParameters(params);
    }
  
    setParameters(params){
      for (var prop in params){
          if (params.hasOwnProperty(prop)){
              var method = "set" + prop.charAt(0).toUpperCase() + prop.slice(1);
              if (this[method]){
                  this[method](params[prop]);
              }
              
          }
      }
    }

    setConnectionId(val){
      this.connectionId = val;
    }
}

export default Facebook;
  